exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quote-panel[data-v-628bb422] {\n  display: inline-block;\n  text-align: left;\n}\n.quote-buttons[data-v-628bb422] {\n  justify-content: center !important;\n}\n.quote-title[data-v-628bb422] {\n  font-size: 18px;\n}\n.margin-center[data-v-628bb422] {\n  margin: auto;\n}", ""]);

// exports
